/* eslint-disable no-shadow */

import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';
import UAParser from 'ua-parser-js';

Vue.use(Vuex);

const uaParser = new UAParser().getResult();

let deviceName = '';

if (uaParser.device.vendor) {
  deviceName = `${uaParser.device.vendor || ''} ${uaParser.device.name || ''}`;
} else {
  deviceName = `${uaParser.browser.name} ${uaParser.browser.version}`;
}

const state = {
  deviceName,
  os: `${uaParser.os.name} ${uaParser.os.version}`,
  dtk: Cookies.get('dtk') || null,
  utk: Cookies.get('utk') || null,
  lactk: null, // line access token
  ltk: null, // line@ bot user
  logged_in: false,
};

const mutations = {
  setDtk(state, dtk) {
    state.dtk = dtk;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.set('dtk', dtk, { expires: 3560 });
    } else {
      Cookies.set('dtk', dtk, { expires: 3560, domain: '.ocard.co' });
    }
  },
  clearDtk(state) {
    state.dtk = null;
    Cookies.remove('dtk');
  },
  setUtk(state, utk) {
    state.utk = utk;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.set('utk', utk, { expires: 3560 });
    } else {
      Cookies.set('utk', utk, { expires: 3560, domain: '.ocard.co' });
    }
  },
  clearUtk(state) {
    state.utk = null;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.remove('utk', { domain: 'localhost' });
      Cookies.remove('utk', { domain: 'order.ocard.co' });
      Cookies.remove('utk', { domain: 'ocard.co' });
      Cookies.remove('utk', { domain: '.ocard.co' });
      Cookies.remove('utk');
    } else {
      Cookies.remove('utk', { domain: 'order.ocard.co' });
      Cookies.remove('utk', { domain: 'ocard.co' });
      Cookies.remove('utk', { domain: '.ocard.co' });
      Cookies.remove('utk');
    }
  },
  masterClearUtk(state) {
    state.utk = null;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
      Cookies.remove('utk');
      Cookies.remove('utk', { domain: 'localhost' });
    } else {
      Cookies.remove('utk', { domain: 'order.ocard.co' });
      Cookies.remove('utk', { domain: 'ocard.co' });
      Cookies.remove('utk', { domain: '.ocard.co' });
      Cookies.remove('utk');
    }
  },
  setLtk(state, ltk) {
    state.ltk = ltk;
  },
  setLactk(state, lactk) {
    state.lactk = lactk;
  },
};

export default {
  state,
  mutations,
};
